var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#02BD8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67728 4.89207L6.24918 8.32016C6.16959 8.39984 6.07507 8.46306 5.97103 8.50619C5.86698 8.54932 5.75546 8.57152 5.64284 8.57152C5.53021 8.57152 5.41869 8.54932 5.31465 8.50619C5.21061 8.46306 5.11609 8.39984 5.03649 8.32016L3.32244 6.60611C3.16163 6.4453 3.07129 6.22719 3.07129 5.99977C3.07129 5.77235 3.16163 5.55424 3.32244 5.39343C3.48326 5.23261 3.70137 5.14227 3.92879 5.14227C4.15621 5.14227 4.37432 5.23261 4.53513 5.39343L5.64284 6.5022L8.46459 3.67938C8.6254 3.51857 8.84351 3.42822 9.07093 3.42822C9.29836 3.42822 9.51646 3.51857 9.67728 3.67938C9.83809 3.84019 9.92843 4.0583 9.92843 4.28572C9.92843 4.51315 9.83809 4.73125 9.67728 4.89207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllow);
export default __webpack_public_path__ + "static/media/allow.5c837f200dcef383a7d9626960706c28.svg";
export { ForwardRef as ReactComponent };